export default __webpack_public_path__ + "static/media/detail_three.69381a9c.png";